import React from 'react';
import { useTranslate } from '@hooks';
import { conversionTypes } from '@dotone/react-ui-core/constants';
import classnames from 'classnames';
import {
  FlexContainer,
  Currency,
  Percentage,
  DetailsCell,
  UncontrolledPopover,
} from '@dotone/react-ui-core';

const OfferPayout = ({ offerId, payouts = [], ...otherProps }) => {
  const { t } = useTranslate('offer', 'model');

  return (
    <td className="text-center align-top" {...otherProps}>
      {payouts.map((payout, index) => {
        const isCustom = payout.type === 'limited';
        const isShared = payout.convType === conversionTypes.CPS;
        const target = `payout-${offerId}-${index}`;

        return (
          <DetailsCell
            key={index}
            invert
            last={index === payouts.length - 1}
            label={payout.label}
            contentProps={{
              className: classnames('text-md font-bold', { 'text-danger': isCustom }),
            }}
          >
            <FlexContainer align="flex-start" justify="center">
              {isCustom && <span>*</span>}
              {isShared ? (
                <Percentage value={payout.value} className="h3" id={target} />
              ) : (
                <Currency truncate value={payout.value} className="h3" id={target} />
              )}
              {isCustom && (
                <UncontrolledPopover target={target} trigger="hover">
                  <div className="d-flex">
                    <span className="mr-1">{t('default')}:</span>
                    {isShared ? (
                      <Percentage value={payout.originalValue} />
                    ) : (
                      <Currency truncate value={payout.originalValue} />
                    )}
                  </div>
                </UncontrolledPopover>
              )}
            </FlexContainer>
          </DetailsCell>
        );
      })}
    </td>
  );
};

export default OfferPayout;
